import { makeStyles } from "@material-ui/core";

import palette from "./palette";

export const useFormInputStyles = makeStyles(theme => ({
  input: {
    border: "3px solid",
    borderRadius: 0,
    borderColor: palette.lightGray,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    fontSize: 16,
    padding: "10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),

    "&:focus, &:focus-within": {
      borderColor: theme.palette.primary.main
    }
  },

  inputLabel: {
    color: theme.palette.primary.main,
    fontWeight: "bold"
  },

  textFieldRootWithError: {
    marginBottom: "8px"
  },

  textFieldRootWithoutError: {
    marginBottom: "30px"
  },

  textFieldInputRoot: {
    "label + &": {
      marginTop: theme.spacing(2.5)
    },
    "& .MuiSelect-icon": {
      top: "calc(50% - 12px)",
      right: "12px",
      color: theme.palette.primary.main
    },
    "&.MuiInputBase-adornedEnd .MuiSelect-icon": {
      right: "68px"
    },
    "& .MuiInputAdornment-root": {
      width: "56px"
    },
    "&.Mui-error input": {
      borderColor: theme.palette.error.main
    }
  },

  selectWithSpacing: {
    margin: `0 ${theme.spacing(1)}px`
  },

  editorInput: {
    border: `1px solid ${palette.midGray}`,
    borderRadius: 0,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    fontSize: 16,
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    width: "100%",

    "&:focus, &:focus-within": {
      borderColor: theme.palette.primary.main
    },

    "&$editorInputError": {
      borderColor: theme.palette.error.main
    },

    "& blockquote": {
      borderLeft: "0.25rem solid #D7D5E0",
      padding: "0.5em 1em",
      margin: "0.5em 0"
    }
  },

  editorInputError: {},

  toolbar: {
    display: "flex",
    alignItems: "center",
    backgroundColor: palette.lightGray
  },

  toolbarButtons: {
    display: "flex",
    alignItems: "center",
    borderLeft: "1px solid #fff",
    borderRight: "1px solid #fff"
  },

  toolbarButton: {
    borderLeft: "1px solid #fff",
    borderRight: "1px solid #fff",
    borderRadius: 0,

    "&:hover": {
      backgroundColor: palette.midGray
    }
  },

  toolbarButtonActive: {
    backgroundColor: palette.darkGray
  }
}));

export const useAutocompleteStyles = makeStyles(() => ({
  inputRoot: {
    marginTop: 10,
    marginBottom: 20,
    '&[class*="MuiOutlinedInput-root"]': {
      padding: "0px",
      "& input": {
        border: 0
      }
    },
    "& fieldset": {
      display: "none"
    }
  },
  inputLabel: {
    marginLeft: -14
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    "& .MuiInputAdornment-root": {
      width: "50px"
    }
  },
  autocompleteContainer: {
    flex: 1
  },
  dataAdornment: {
    width: 40,
    marginTop: 10,
    marginLeft: 4,
    "& .MuiCircularProgress-root": {
      marginTop: 10,
      marginLeft: 10
    }
  }
}));
